import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'uw-avatar',
  standalone: true,
  template: `
    <span
      class="inline-flex select-none items-center justify-center rounded-full font-semibold"
      [class]="classes()"
      [attr.aria-label]="label()"
    >{{ initials() }}</span>
  `,
})
export class UwAvatar {
  readonly initials = input.required<string>();
  readonly label = input<string>('');
  readonly size = input<'xs' | 'sm' | 'md' | 'lg'>('sm');
  readonly tone = input<'default' | 'accent' | 'ai'>('default');

  protected readonly classes = computed(() => {
    const sizes = {
      xs: 'h-5 w-5 text-[9px]',
      sm: 'h-7 w-7 text-[11px]',
      md: 'h-9 w-9 text-[12px]',
      lg: 'h-12 w-12 text-[15px]',
    } as const;
    const tones = {
      default: 'bg-primary-soft text-primary',
      accent: 'bg-accent text-white',
      ai: 'bg-ai text-white',
    } as const;
    return `${sizes[this.size()]} ${tones[this.tone()]}`;
  });
}
